import React from 'react';
import { Table, OverlayTrigger, Tooltip, Dropdown, Button } from 'react-bootstrap';

const TaskslistTable = ({
    onEdit,
    onDelete,
    onViewHistory,
    onContactClick
}) => {
    const [expandedRows, setExpandedRows] = React.useState(new Set());

    const toggleRow = (index) => {
        const newExpandedRows = new Set(expandedRows);
        if (newExpandedRows.has(index)) {
            newExpandedRows.delete(index);
        } else {
            newExpandedRows.add(index);
        }
        setExpandedRows(newExpandedRows);
    };
    return (
        <Table responsive className='c-table'>
            <thead>
                <tr>
                    <th colSpan={5}>Tasklist Name</th>
                </tr>
            </thead>
            <tbody>
                {[...Array(5)].map((_, i) => (
                    <React.Fragment key={i}>
                        <tr>
                            <td colSpan={5}>
                                <div className='d-flex align-items-center'>
                                    <Button variant="link" className='me-3' onClick={() => toggleRow(i)}>
                                        <i className={`fas fa-chevron-${expandedRows.has(i) ? 'down' : 'right'}`}></i>
                                    </Button>
                                    <div className='d-flex align-items-center'>
                                        <div className='c-avatar c-avatar-text'>
                                            E
                                        </div>
                                        <div>
                                            <div className='p-tag fw-bold'>eCommerce Website</div>
                                            <div className='p-tag fs-12'>Date: 01/01/2023 to 01/31/2023</div>
                                            <div className='p-tag fs-12'>Tasklists: 12</div>
                                        </div>
                                    </div>
                                </div>                                
                            </td>
                        </tr>
                        {expandedRows.has(i) && (
                            <>
                                {[...Array(5)].map((_, i) => (
                                    <React.Fragment key={i}>
                                        <tr>
                                            <th>Tasklist Name</th>
                                            <th width="180px" className='text-center'>Workflow</th>
                                            <th width="100px" className='text-center'>Assign</th>
                                            <th width="180px" className='text-center text-nowrap'>Timeline Progress</th>
                                            <th width="50px" className='text-center'>Actions</th>
                                        </tr>
                                        <tr className='sub-row'>
                                            <td>
                                                <div className='p-tag fw-bold'>Misc. Tasks</div>
                                                <div className='p-tag'>0/4 Tasks</div>
                                            </td>
                                            <td className='text-center'>
                                                <div className='p-tag fw-bold'>Design Workflow</div>
                                                <div className='p-tag'>11 Steps</div>
                                            </td>
                                            <td className='text-center'>
                                                <div className='d-flex align-items-center justify-content-center'>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>John Doe</Tooltip>}
                                                    >
                                                        <div 
                                                            className='c-avatar c-avatar-text c-avatar-sm me-0' 
                                                            onClick={() => onContactClick({
                                                                id: 1,
                                                                name: 'John Doe',
                                                                initials: 'JD',
                                                                email: 'john.doe@example.com',
                                                                role: 'Developer'
                                                            })}
                                                        >
                                                            JD
                                                        </div>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>Jane Smith</Tooltip>}
                                                    >
                                                        <div 
                                                            className='c-avatar c-avatar-text c-avatar-sm me-0' 
                                                            onClick={() => onContactClick({
                                                                id: 2,
                                                                name: 'Jane Smith',
                                                                initials: 'JS',
                                                                email: 'jane.smith@example.com',
                                                                role: 'Designer'
                                                            })}
                                                        >
                                                            JS
                                                        </div>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip>+3 Members</Tooltip>}
                                                    >
                                                        <div 
                                                            className='c-avatar c-avatar-text c-avatar-sm me-0' 
                                                            onClick={() => onContactClick({
                                                                id: 3,
                                                                name: 'Multiple Members',
                                                                initials: '+3',
                                                                type: 'group'
                                                            })}
                                                        >
                                                            +3
                                                        </div>
                                                    </OverlayTrigger>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-column align-items-start">
                                                    <div className="p-tag fw-bold fs-12 mb-1">239h 0m (40%)</div>
                                                    <div className="c-progress-bar mb-1"><div className="c-progress-fill" style={{ width: '50%', background: 'linear-gradient(90deg, #34d399 0%, #10b981 100%)' }}></div></div>
                                                    <div className="p-tag fs-12 d-flex justify-content-between w-100">
                                                        <div>250 Tasks</div>
                                                        <div>118 Tasks Left</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className='text-center'>
                                                <Dropdown className='c-dropdown-1'>
                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                        <i className="fas fa-ellipsis-v"></i>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={onEdit}><i className="fas fa-edit me-2"></i> Edit</Dropdown.Item>
                                                        <Dropdown.Item onClick={onViewHistory}><i className="fas fa-history me-2"></i> View History</Dropdown.Item>
                                                        <Dropdown.Item onClick={onDelete} className='text-danger'><i className="fas fa-trash me-2"></i> Delete</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                        <tr className='sub-row'>
                                            <td colSpan={5} className='p-0'>
                                                <Table className='c-table'>
                                                    <thead>
                                                        <tr>
                                                            <th width="8.33%" className='text-center text-nowrap'>Backlog</th>
                                                            <th width="8.33%" className='text-center text-nowrap'>In <br/>Progress</th>
                                                            <th width="8.33%" className='text-center text-nowrap'>TL <br/>Review</th>
                                                            <th width="8.33%" className='text-center text-nowrap'>Reopened</th>
                                                            <th width="8.33%" className='text-center text-nowrap'>PM <br/>Review</th>
                                                            <th width="8.33%" className='text-center text-nowrap'>Send to <br/>Dev.</th>
                                                            <th width="8.33%" className='text-center text-nowrap'>Assign <br/>to QC</th>
                                                            <th width="8.33%" className='text-center text-nowrap'>Bug <br/>Fixing</th>
                                                            <th width="8.33%" className='text-center text-nowrap'>QA Bug <br/>Verification</th>
                                                            <th width="8.33%" className='text-center text-nowrap'>Deploy <br/>to Beta</th>
                                                            <th width="8.33%" className='text-center text-nowrap'>Deploy <br/>to Live</th>
                                                            <th width="8.33%" className='text-center text-nowrap'>On Hold</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td className='text-center'>0</td>
                                                            <td className='text-center'>0</td>
                                                            <td className='text-center'>0</td>
                                                            <td className='text-center'>0</td>
                                                            <td className='text-center'>0</td>
                                                            <td className='text-center'>0</td>
                                                            <td className='text-center'>0</td>
                                                            <td className='text-center'>0</td>
                                                            <td className='text-center'>0</td>
                                                            <td className='text-center'>0</td>
                                                            <td className='text-center'>0</td>
                                                            <td className='text-center'>0</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                            </>
                        )}
                    </React.Fragment>
                ))}
            </tbody>
        </Table>
    );
};

export default TaskslistTable;
